export default [
  {
    path: '/opportunities',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'opportunities-list' */ '@/views/opportunities/List.vue')
  },
  {
    path: '/opportunities/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'opportunities-create' */ '@/views/opportunities/Create.vue')
  },
  {
    path: '/opportunities/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'opportunity-page' */ '@/views/opportunities/Opportunity.vue')
  },
  {
    path: '/opportunities/:id/applicants',
    props: true,
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'opportunity-applicants' */ '@/views/opportunities/ApplicationsTracker.vue')
  },
  {
    path: '/opportunities/:id/batch',
    props: true,
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'opportunity-batch' */ '@/views/opportunities/Batch.vue')
  },
  {
    path: '/opportunities/:id/demographics',
    props: true,
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'opportunity-demographics' */ '@/views/opportunities/Demographics.vue')
  },
]
